import * as actionTypes from './actionTypes';

export const fetchAllGlobalPermissions = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllGlobalPermissionsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const updateGlobalPermission = (globalPermission) => ({
  type: actionTypes.UPDATE,
  globalPermission,
});
export const updateGlobalPermissionsuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});
